<template>
  <form @submit.stop.prevent>
    <div class="field has-addons">
      <div class="control is-expanded">
        <input
          type="text"
          name="tags"
          v-model="newTag"
          id="tags"
          :maxlength="max"
          class="input is-margin-right"
          @keyup.enter.prevent="addTag"
          :placeholder="placeholder">
      </div>
      <div class="control">
        <a
          class="button is-square"
          @click="addTag"
          :class="newTag && newTag.length ? 'is-success' : ''">
          <i class="fas fa-save"></i>
        </a>
      </div>
    </div>
    <div
      v-if="maxTags && flashMaxTagError"
      class="has-background-warning is-padding-xsmall">
      <p>Max {{ maxTags }} tags</p>
    </div>
    <div class="field is-grouped is-grouped-multiline">
      <div
        class="control"
        v-for="(tag, index) in tags"
        :key="index">
        <div class="tags has-addons">
          <span class="tag is-annonce">{{ tag }}</span>
          <a
            class="tag is-delete is-annonce"
            @click="removeTag(index)"></a>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
export default {
  name: 'TagInput',
  props: {
    tags: {
      required: true
    },
    placeholder: {
      required: false
    },
    maxTags: Number,
    max: Number
  },
  data () {
    return {
      newTag: '',
      flashMaxTagError: false
    }
  },
  watch: {
    newTag (value) {
      if (!this.tags) this.tags = []
      if (value.includes(',')) {
        var tag = value.split(',')
        this.tags.push(tag[0])
        this.newTag = ''
        this.$emit('tagChange', this.tags)
      }
    }
  },
  methods: {
    addTag () {
      if (!this.tags) this.tags = []
      if (this.tags.length >= this.maxTags) {
        this.flashMaxTagError = true
        return
      } else this.flashMaxTagError = false
      if (!this.newTag.length) return
      this.tags.push(this.newTag)
      this.newTag = ''
      this.$emit('tagChange', this.tags)
    },
    removeTag (index) {
      this.tags.splice(index, 1)
      this.$emit('tagChange', this.tags)
    }
  }
}
</script>
